<div class="preferences-popup">
  <div class="popup-img"><img src="assets/images/preferences/popup.jpeg" alt="logo" /></div>
  <h1 mat-dialog-title cdkFocusInitial>{{ 'Preferences:OverlayBoxTitle' | translate }}</h1>

  <mat-dialog-content>
    <div class="subtitle">{{ 'Preferences:YourPreferencesSubtitle' | translate }}</div>
    <div class="artist-list">
      <ng-container *ngIf="!isPreferencesPopup; else artistCard">
        <ten-artist-card class="artist-card" *ngFor="let card of cards" [card]="card"></ten-artist-card>
      </ng-container>
      <ng-template #artistCard>
        <ten-interest-card class="artist-card" *ngFor="let card of cards" [card]="card"></ten-interest-card>
      </ng-template>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (accessibleClick)="onSkipClick()">
      {{ (isPreferencesPopup ? 'Preferences:Skip' : 'Preferences:Close') | translate }}
    </button>
    <button mat-raised-button mat-dialog-close color="primary" (accessibleClick)="onDiscoverMoreClick()">
      {{ 'Preferences:DiscoverMore' | translate }}
    </button>
  </mat-dialog-actions>

  <button
    mat-icon-button
    class="artist-popup-close-button"
    tabindex="0"
    role="button"
    aria-label="close"
    (accessibleClick)="onCloseClick()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
